import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logOutAction, selectAuthLoading } from "./authSlice";
import { FullScreenSpinner } from "../components/FullScreenSpinner";

const Logout = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectAuthLoading);

  useEffect(() => {
    dispatch(logOutAction());
  }, [dispatch]);

  if (loading) {
    return <FullScreenSpinner />;
  }

  return <Navigate to="/" replace />;
};

export default Logout;
